exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-form-item .ant-form-item-label{min-width:120px!important;width:unset}", ""]);

// exports
